import * as React from 'react';

export const ConfigureContext = React.createContext({});
